import { useParams } from "react-router-dom";
import CC25 from "./2025/CC25A7xPqL9m";
import QF25 from "./2025/QF25C1rWv4nJ";
import QS25 from "./2025/QS25Dg5sYh2X";
import EO25 from "./2025/EO25Bf3kTz8Q";


import { JSX } from "react";

// マップ（キーが `id` 部分）
const pageMap: { [id: string]: JSX.Element } = {
  CC25A7xPqL9m: <CC25 />,
  QF25C1rWv4nJ: <QF25 />,
  QS25Dg5sYh2X: <QS25 />,
  EO25Bf3kTz8Q: <EO25 />,
};

export default function PublicResultPageWrapper() {
  const { id } = useParams<{ id: string }>();

  const Page = id ? pageMap[id] : null;

  return Page ?? <div>ページが見つかりません</div>;
}
